import { render, staticRenderFns } from "./SupplierCSR.vue?vue&type=template&id=184d827a&scoped=true"
import script from "./SupplierCSR.vue?vue&type=script&lang=js"
export * from "./SupplierCSR.vue?vue&type=script&lang=js"
import style0 from "./SupplierCSR.vue?vue&type=style&index=0&id=184d827a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184d827a",
  null
  
)

export default component.exports